import { render, staticRenderFns } from "./menuLateral.vue?vue&type=template&id=a2b48fc2&scoped=true"
import script from "./menuLateral.vue?vue&type=script&lang=js"
export * from "./menuLateral.vue?vue&type=script&lang=js"
import style0 from "./menuLateral.vue?vue&type=style&index=0&id=a2b48fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b48fc2",
  null
  
)

export default component.exports